export default __webpack_public_path__ + "static/media/research.214fd12b.svg";